<div class="w-full p-32 max-w-full max-h-[80vh] relative">
  <div class="absolute right-8 top-8">
    <button blazeIconButton="bat" blazeIconButtonSize="lg" (click)="closeDialog()">
      <mat-icon svgIcon="close" />
    </button>
  </div>
  <h1 class="mb-24">Edit {{ columnLabel || 'Paragraph' }}</h1>
  <textarea
    #stringInput
    class="textarea-input"
    [formControl]="paragraphFormControl"
    (keydown)="enterKeydown($event)"
  ></textarea>
</div>
